"use strict";

import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { IconGlyphicon, IconFontAwesome } from 'generics/icons';
import { BootButton, CloseButton } from 'generics/buttons';


export class ViewMarketSortOrder extends React.Component  {
  constructor( props )  {
    super( props );
    this.state = {};

    this.SORT_FIELDS = [
      {
        "key" : "n",    "name" : _I_("MarketSortOrder.label.name"),    "start" : "name_asc",
        "states" :  {
          "name_asc":    { "next": "name_desc", "icon":"sort-alpha-asc", "title": _I_("MarketSortOrder.hint.nameAsc") },
          "name_desc":   { "next": "name_asc", "icon":"sort-alpha-desc", "title": _I_("MarketSortOrder.hint.nameDesc") },
        },
      },

      {
        "key" : "u",    "name" : _I_("MarketSortOrder.label.popular"),    "start" : "",
        "states" :  {
          "" :    { "next": "", "title": _I_("MarketSortOrder.hint.popular"), "icon":"star-half-o" }
        },
      },

      {
        "key" : "p",    "name" : _I_("MarketSortOrder.label.price"),    "start" : "price_desc",
        "states" :  {
          "price_asc":    { "next": "price_desc", "icon":"sort-numeric-asc", "title": _I_("MarketSortOrder.hint.priceAsc") },
          "price_desc":   { "next": "price_asc", "icon":"sort-numeric-desc", "title": _I_("MarketSortOrder.hint.priceDesc") },
        },
      },

      {
        "key" : "q",    "name" : _I_("MarketSortOrder.label.amount"),    "start" : "depth_desc",
        "states" :   {
          "depth_asc":    { "next": "depth_desc", "icon":"sort-amount-asc", "title": _I_("MarketSortOrder.hint.amountAsc") },
          "depth_desc":   { "next": "depth_asc", "icon":"sort-amount-desc", "title": _I_("MarketSortOrder.hint.amountDesc") },
        },
      },

    ];
  }


  renderSortGroup(ent)  {
    const order = this.props.sortOrder;
    const isActive = !!ent.states[order];
    const visibleState = isActive ? ent.states[order] : ent.states[ent.start];
    const next = isActive ? visibleState.next : ent.start;
    const handler = () =>  this.props.onChange( next );
    return  (
        <BootButton key={ent.key}  size="small"
                    variant={isActive?"danger":"default"}
                    title={visibleState.title}
                    onClick={handler}
                      >
            {ent.name}&nbsp;<IconFontAwesome type={visibleState.icon} />
        </BootButton>
      );
  }


  render()  {
    return (
        <div className="market-sort-menu">
        {this.SORT_FIELDS.map( 
            (ent) =>  this.renderSortGroup(ent)
          )}
        </div>
      );
  }
}


defineSimpleTerm( "MarketSortOrder.label.name",  "Name",       {
  "ru_RU": "Имя",
  "cs_CZ": "Name",
  "fr_FR": "Nom",
  "de_DE": "Name",
  "it_IT": "Nome",
  "ko_KR": "이름",
  "pl_PL": "Nazwa",
  "pt_PT": "Name",
  "es_ES": "Nombre",
  "zh_CN": "名称",
  "zh_TW": "名稱"
} );


defineSimpleTerm( "MarketSortOrder.hint.nameAsc",  "By name ascending",       {
  "ru_RU": "По нарастанию имени",
  "cs_CZ": "By name ascending",
  "fr_FR": "Par noms (A-Z)",
  "de_DE": "Nach Namen aufsteigend",
  "it_IT": "Per nome ascendente",
  "ko_KR": "이름순으로 나열",
  "pl_PL": "Po nazwie rosnąco",
  "pt_PT": "By name ascending",
  "es_ES": "Por nombre ascendente",
  "zh_CN": "按名称升序",
  "zh_TW": "按名稱升序"
} );


defineSimpleTerm( "MarketSortOrder.hint.nameDesc",  "By name descending",       {
  "ru_RU": "По убыванию имени",
  "cs_CZ": "By name descending",
  "fr_FR": "Par noms (Z-A)",
  "de_DE": "Nach Namen absteigend",
  "it_IT": "Per nome discendente",
  "ko_KR": "이름 역순으로 나열",
  "pl_PL": "Po nazwie malejąco",
  "pt_PT": "By name descending",
  "es_ES": "Por nombre descendente",
  "zh_CN": "按名称降序",
  "zh_TW": "按名稱降序"
} );


defineSimpleTerm( "MarketSortOrder.label.price",  "Price",       {
  "ru_RU": "Цена",
  "cs_CZ": "Price",
  "fr_FR": "Prix",
  "de_DE": "Preis",
  "it_IT": "Prezzo",
  "ko_KR": "가격",
  "pl_PL": "Cena",
  "pt_PT": "Price",
  "es_ES": "Precio",
  "zh_CN": "价格",
  "zh_TW": "價格"
} );


defineSimpleTerm( "MarketSortOrder.hint.priceAsc",  "Low to high cost",       {
  "ru_RU": "По нарастанию цен",
  "cs_CZ": "Low to high cost",
  "fr_FR": "Du coût le plus bas au plus élevé",
  "de_DE": "Niedrige bis hohe Kosten",
  "it_IT": "Dal prezzo più basso al più alto",
  "ko_KR": "낮은 가격 순으로 나열",
  "pl_PL": "Od najtańszego do najdroższego",
  "pt_PT": "Low to high cost",
  "es_ES": "Coste bajo a alto",
  "zh_CN": "价格从低到高",
  "zh_TW": "價格從低到高"
} );


defineSimpleTerm( "MarketSortOrder.hint.priceDesc",  "High to low cost",       {
  "ru_RU": "По убыванию цен",
  "cs_CZ": "High to low cost",
  "fr_FR": "Du coût le plus élevé au plus bas",
  "de_DE": "Hohe bis niedrige Kosten",
  "it_IT": "Dal prezzo più alto al più basso",
  "ko_KR": "높은 가격 순으로 나열",
  "pl_PL": "Od najdroższego do najtańszego",
  "pt_PT": "High to low cost",
  "es_ES": "Coste alto a bajo",
  "zh_CN": "价格从高到低",
  "zh_TW": "價格從高到低"
} );


defineSimpleTerm( "MarketSortOrder.label.amount",  "Quantity",       {
  "ru_RU": "Колич-во",
  "cs_CZ": "Quantity",
  "fr_FR": "Quantité",
  "de_DE": "Anzahl",
  "it_IT": "Quantità",
  "ko_KR": "수량",
  "pl_PL": "Ilość",
  "pt_PT": "Quantity",
  "es_ES": "Cantidad",
  "zh_CN": "数量",
  "zh_TW": "數量"
} );


defineSimpleTerm( "MarketSortOrder.hint.amountAsc",  "Low to high amounts",       {
  "ru_RU": "По нарастанию количества",
  "cs_CZ": "Low to high amounts",
  "fr_FR": "Du montant le plus bas au plus élevé",
  "de_DE": "Niedrige bis hohe Summe",
  "it_IT": "Dal prezzo più basso al più alto",
  "ko_KR": "적은 수량부터 나열",
  "pl_PL": "Od najrzadszych do najliczniejszych",
  "pt_PT": "Low to high amounts",
  "es_ES": "Cantidad baja a alta",
  "zh_CN": "数量从低到高",
  "zh_TW": "數量從低到高"
} );


defineSimpleTerm( "MarketSortOrder.hint.amountDesc",  "High to low amounts",       {
  "ru_RU": "По убыванию количества",
  "cs_CZ": "High to low amounts",
  "fr_FR": "Du montant le plus élevé au plus bas",
  "de_DE": "Hohe bis niedrige Summe",
  "it_IT": "Dal prezzo più alto al più basso",
  "ko_KR": "많은 수량부터 나열",
  "pl_PL": "Od najliczniejszych do najrzadszych",
  "pt_PT": "High to low amounts",
  "es_ES": "Cantidad alta a baja",
  "zh_CN": "数量从高到低",
  "zh_TW": "數量從高到低"
} );


defineSimpleTerm( "MarketSortOrder.label.popular",  "Popular",       {
  "ru_RU": "Популярные",
  "cs_CZ": "Popular",
  "fr_FR": "Populaire",
  "de_DE": "Beliebt",
  "it_IT": "Popolare",
  "ko_KR": "인기도",
  "pl_PL": "Popularność",
  "pt_PT": "Popular",
  "es_ES": "Popular",
  "zh_CN": "人气",
  "zh_TW": "人氣"
} );


defineSimpleTerm( "MarketSortOrder.hint.popular",  "Popular first",       {
  "ru_RU": "Популярные вначале",
  "cs_CZ": "Popular first",
  "fr_FR": "Populaire en premier",
  "de_DE": "Beliebte zuerst",
  "it_IT": "Prima il più popolare",
  "ko_KR": "인기순으로 나열",
  "pl_PL": "Najpopularniejsze",
  "pt_PT": "Popular first",
  "es_ES": "Popular primero",
  "zh_CN": "人气最高",
  "zh_TW": "人氣最高"
} );

